import React from "react";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageHeader from "../pageheader/PageHeader";
import ManuOperation from "./navOperationRoom/ManuOperation";

import styles from './InspectionGuide.module.css'

function InspectionGuideDetail() {

    const nav = useNavigate()
    const location = useLocation()

    const [title, setTitle] = useState('')
    const [detail, setDetail] = useState('')

    useEffect(() => {
        if (location.state?.type === 'view') {
            // console.log(location.state)
            setTitle(location.state?.title)
            setDetail(location.state?.detail)
        }
    }, [])

    return (
      <div class="bg-[#ffffff] pb-[30px]">
        <div className={styles.blockContent}>
          <div
            className={`text-3xl md:text-[18px] flex font-bold mt-2 mb-4 font-['Prompt-SemiBold'] `}
          >
            แนวทางการตรวจ
          </div>
          <div className="border px-2 py-4">
            <div>
              <div className={styles.textTitle}>{title}</div>
              <br/>
              <div dangerouslySetInnerHTML={{ __html: detail }} />
            </div>
          </div>
        </div>
      </div>
    );
}
export default InspectionGuideDetail